import type { IconNames } from '@petsmart-ui/sparky';

import type { PharmacyType } from '@/entities/product/api/base/dto';

export const PHARMACY_TYPE_DATA_MAP: Record<PharmacyType, { text: string; icon: IconNames }> = {
    rx_food: { text: 'Vet authorization required', icon: 'circle-plus' },
    rx_med: { text: 'Prescription info required', icon: 'circle-rx' },
};
